import { useMemo } from 'react';
import { useAppContext } from '../../../app/Context';
import { usePusherChannel } from '../../../pusher';
import { PusherChannel } from '../../../pusher/types';
import { useCourseContext } from '../Context';

const useCourseChannel = () => {
  const { session } = useAppContext();
  const { course } = useCourseContext();

  // memoized channelIdentifier is needed to avoid frequent pusher connection/disconnection
  const [userId, channelIdentifier] = useMemo(() => {
    const userId = session?.userId;
    const courseId = course?.id;

    if (!courseId) return [userId, null] as const;

    return [
      userId,
      {
        id: `private-course-${courseId}`,
        name: PusherChannel.COURSE,
      },
    ] as const;
  }, [session?.userId, course?.id]);

  usePusherChannel(userId, channelIdentifier);
};

export default useCourseChannel;
